<template>
    <tr :class="isDmeNeededFormOpen || isDeleteRequested ? 'edit-row' : ''">
        <td>
            <EmptyTextHandler :text="dme.dmeName" />
        </td>
        <td>
            <EmptyTextHandler :text="dme.provider" />
        </td>
        <td>
            <EmptyTextHandler :text="dme.serialNo" />
        </td>
        <td>
            <EmptyTextHandler :text="dme.modelNo" />
        </td>
        <td v-if="!isDmeNeededFormOpen && !isDeleteRequested">
            <button type="button" class="btn table-btn" @click="showDmeNeededForm(true)">Edit</button>
            <span> | </span>
            <button type="button" class="btn table-btn" @click="requestDeleteContact()">Delete</button>
        </td>
        <td v-if="isDmeNeededFormOpen">
            <i class="fw-bold"> {{ isEditRequested ? "Editing In Progress" : "View In Progress" }} </i>
        </td>
        <td colspan="5" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="delete"
                name="Delete"
                :is-in-progress="isDeleteInProgress"
                :ok="deleteDmeNeeded(dme.id)"
                :cancel="cancelDeleteContact"
            ></TablePrompt>
        </td>
    </tr>

    <!-- Form Editing -->
    <tr v-if="isDmeNeededFormOpen" class="edit-row">
        <td :colspan="columns" class="p-3">
            <div class="col-12 row">
                <div class="form-group col-12 col-lg-6">
                    <label for="equipment-name"> Equipment Name </label>
                    <p>
                        <EmptyTextHandler :text="dme.dmeName" />
                    </p>
                </div>
                <div class="form-group col-12 col-lg-6">
                    <label for="provider-name"> Provider Name </label>
                    <input type="text" class="form-control" v-model="dme.provider" />
                </div>
            </div>
            <div class="col-12 row">
                <div class="form-group col-12 col-lg-6">
                    <label for="model-no"> Model Number </label>
                    <input type="text" class="form-control" v-model="dme.modelNo" />
                </div>
                <div class="form-group col-12 col-lg-6">
                    <label for="serial-no"> Serial Number </label>
                    <input type="text" class="form-control" v-model="dme.serialNo" />
                </div>
            </div>

            <footer class="d-flex justify-content-center pt-3" v-if="!isSaving">
                <button type="button" class="btn btn-primary me-2 mb-2" @click="saveDme(dme.id)">Save</button>
                <button type="button" class="btn btn-outline-primary mb-2" @click="closeDmeNeededForm()">Cancel</button>
            </footer>
        </td>
    </tr>
</template>

<script lang="ts" src="./EditDmeNeededRow.ts"></script>
